import { render } from "./DocumentPatient.vue?vue&type=template&id=0fe74d94"
import script from "./DocumentPatient.vue?vue&type=script&lang=js"
export * from "./DocumentPatient.vue?vue&type=script&lang=js"

import "./DocumentPatient.vue?vue&type=style&index=0&id=0fe74d94&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__